import React from 'react';

const UserPlaceholderImg = (props: any) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="32" height="32" rx="16" fill="#F2E5FF" />
    <mask
      id="mask0_7552_5648"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="32"
    >
      <rect width="32" height="32" rx="16" fill="#F2E5FF" />
    </mask>
    <g mask="url(#mask0_7552_5648)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2426 15.2426C22.5858 12.8995 22.5858 9.10049 20.2426 6.75735C17.8995 4.41422 14.1005 4.41422 11.7574 6.75735C9.41421 9.10049 9.41421 12.8995 11.7574 15.2426C14.1005 17.5858 17.8995 17.5858 20.2426 15.2426ZM24.4853 40.4853C29.1716 35.799 29.1716 28.201 24.4853 23.5147C19.799 18.8284 12.201 18.8284 7.51471 23.5147C2.82843 28.201 2.82843 35.799 7.51471 40.4853C12.201 45.1716 19.799 45.1716 24.4853 40.4853Z"
        fill="#DDBEFE"
      />
    </g>
  </svg>
);

export default UserPlaceholderImg;
